import { Injectable, Injector } from '@angular/core';
import { Observable, of, Subscriber } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoggerService } from '../../../services/logger/logger.service';
import { ProductPricelist } from '../models/product-pricelist';
import { PricelistService } from './pricelist.service';
import { Product } from '../../order/models/product';
import { Order } from '../../order/models/order';
import { SalePriceScheduleStateService } from '../../booking/services/sale-price-schedule-state.service';
import { BookingSlot } from '../../booking/models/booking-slot';
import { Partner } from '../../partner/models/partner';
import { GlobalSettings } from 'src/environments/global-settings';


@Injectable()
export class PriceListStateService {
  private _currentPricelist = new ProductPricelist();
  private _defaultPricelist = new ProductPricelist();

  constructor(
    private logger: LoggerService,
    private pricelistService: PricelistService,
    private salePriceScheduleStateService: SalePriceScheduleStateService,
  ) {
  }

  initialize(): Observable<boolean> {
    return Observable.create(
      (observable: Subscriber<boolean>) => {
        this.logger.info(`PriceListStateService: initialize.`);
        this.loadDefaultPricelist().subscribe(
          done => {
            this.logger.info(`PriceListStateService: loadDefaultPricelist done.`);
            this.reset();
            observable.next(done);
          },
          error => {
            this.logger.info(`PriceListStateService: loadDefaultPricelist initialize failed ${error}.`);
            observable.error(error);
          },
          () => {
            // observable.complete();
          }
        );
      });
  }

  loadPricelistById(pricelistId: number): Observable<boolean> {
    const existProductPricelist = this.isProductPricelistExist(pricelistId);
    if (existProductPricelist) {
      return of(false);
    }

    return this.pricelistService.getPricelistById(pricelistId)
      .pipe(map(
        (result: ProductPricelist) => {
          if (result) {
            this._currentPricelist = result;
            return true;
          }
          return false;
        }
      ));
  }

  loadDefaultPricelist(): Observable<boolean> {
    return this.pricelistService.getDefaultPricelist()
      .pipe(map(
        (result: ProductPricelist) => {
          if (result) {
            this._defaultPricelist = result;
            this._currentPricelist = result;
            return true;
          }
          return false;
        }
      ));
  }

  get currentPricelist(): ProductPricelist {
    return this._currentPricelist;
  }

  get defaultPricelist(): ProductPricelist {
    return this._defaultPricelist;
  }

  reset() {
    this._currentPricelist = this._defaultPricelist;
  }

  isProductPricelistExist(pricelistId: number): boolean {
    const currentPricelist = this.currentPricelist;
    if (currentPricelist) {
      return this.currentPricelist.id === pricelistId;
    }
    return false;
  }

  computePrice(product: Product, qty: number, partner: Partner, order: Order, productVals: {}, bookingSlots: BookingSlot[]) {
    let pricelist = null;
    const orderPricelist = order && order.productPricelist ? order.productPricelist : null;
    const partnerPricelist = partner && partner.productPricelist ? partner.productPricelist : null;

    if (partnerPricelist) {
      pricelist = partnerPricelist;
    }

    if (orderPricelist && !pricelist) {
      pricelist = orderPricelist;
    }

    if (!pricelist) {
      pricelist = this.currentPricelist;
    }

    // if (order) {
    //   qty = this._get_product_qty_from_order(qty, order, product);
    // }

    let productPriceSchedules = null;

    if (product && product.productPriceSchedules && product.productPriceSchedules.length > 0) {
      productPriceSchedules = product.productPriceSchedules;
    }

    if (!productPriceSchedules && productVals && productVals['productPriceSchedules']) {
      productPriceSchedules = productVals['productPriceSchedules'];
    }


    let schedulePrice = null;
    if (productPriceSchedules && productPriceSchedules.length > 0) {
      const actualSalePriceScheduleTypeIds = this.salePriceScheduleStateService.getActualSalePriceScheduleTypeIds(bookingSlots);

      for (const actualSalePriceScheduleTypeId of actualSalePriceScheduleTypeIds) {
        for (const productPriceSchedule of productPriceSchedules) {
          if (productPriceSchedule && productPriceSchedule.salePriceScheduleType && productPriceSchedule.salePriceScheduleType.id === actualSalePriceScheduleTypeId) {
            schedulePrice = productPriceSchedule.schedulePrice;
            break;
          }
        }
        if (schedulePrice !== null) {
          break;
        }
      }
    }

    const productId = product ? product.id : productVals['id'];
    let productPrice = null;

    if (schedulePrice !== null) {
      productPrice = schedulePrice;
    } else {
      productPrice = product ? product.price : productVals['price'];
    }

    qty = qty || qty === 0 ? qty : productVals['qty'];
    // const productCategId = product ? product.categId : productVals['categId'];

    // TODO categ logic all pare
    // const categIds = [];

    // TODO sortder items

    const version = this.findValidPricelistVersion(pricelist);
    if (!version) {
      return productPrice;
    }

    const items = [];
    for (const item of version.productPricelistItems) {
      if (item.name &&
        (item.productId === false && item.categId === false && item.productTmplId === false
          || item.productId === productId)
        // && (!item.categId || categIds.indexOf(item.categId) !== -1)
      ) {
        items.push(item);
      }
    }

    let price = null;

    for (const rule of items) {
      if (rule.minQuantity && qty < rule.minQuantity) {
        continue;
      }
      if (rule.productId && rule.productId !== productId) {
        continue;
      }
      // if (rule.categId) {}
      price = productPrice;

      if (price !== null) {
        const price_limit = price;
        price = price * (1.0 + (rule.priceDiscount ? rule.priceDiscount : 0.0));

        if (rule.priceRound) {
          price = parseFloat(price.toFixed(
            Math.ceil(Math.log(1.0 / rule.priceRound) / Math.log(10)))
          );
        }

        price += (rule.priceSurcharge ? rule.priceSurcharge : 0.0);

        if (rule.priceMinMargin) {
          price = Math.max(price, price_limit + rule.priceMinMargin);
        }

        if (rule.priceMaxMargin) {
          price = Math.min(price, price_limit + rule.priceMaxMargin);
        }

      }
      break;
    }

    return price;
  }

  findValidPricelistVersion(pricelist: ProductPricelist) {
    let version = null;
    if (!pricelist) {
      return version;
    }

    const currentDate = GlobalSettings.DateNow;
    for (const v of pricelist.pricelistVersions) {
      if (((!v.dateStart) || (new Date(v.dateStart) <= currentDate)) && ((!v.dateEnd) || (new Date(v.dateEnd) <= currentDate))) {
        version = v;
        break;
      }
    }

    return version;
  }
}
